import { UserProfile, UserProfileResponse } from '../entities/models/user-profile.model';
import { User } from '../entities/models/user.model';
import { transformSnakeToCamel } from './transformers';

export function transformUserProfileResponse(profileResponse: UserProfileResponse): UserProfile {
  return transformSnakeToCamel(profileResponse) as UserProfile;
}

export function transformUserResponse(userResponse: any): User {
  return transformSnakeToCamel(userResponse) as User;
}

